import React from "react";
import UnityCodeEditor from '@bit/smartworks.unity-react.unity-code-editor-react';
import './UnityJsonViewer.css';
export default class UnityJsonViewer extends React.Component {
    render() {
        const { src = '', style = {} } = this.props;
        let formattedStr;
        try {
            formattedStr = JSON.stringify(JSON.parse(src), null, 2);
        }
        catch (e) {
            formattedStr = src;
        }
        return (React.createElement("div", { onClick: e => {
                e.preventDefault();
                e.stopPropagation();
            }, style: Object.assign(Object.assign({}, styles.readOnlyJSON), style), className: "read-only-json" },
            React.createElement("div", { style: styles.editorWrapper },
                React.createElement(UnityCodeEditor, { value: formattedStr, key: `json-readonly`, label: "", mode: 'json5', readOnly: true, onChange: () => { }, error: "", highlightActiveLine: false, showLineNumbers: false, minLines: 1, maxLines: 30 }))));
    }
}
const styles = {
    readOnlyJSON: {
        "--active-color": "rgba(0,0,0,0)",
        "--gutter-color": "#FFF",
        "--border-color": "rgba(0,0,0,0)",
        "--fold-color": "#FFF",
        display: "relative",
        overflow: "hidden"
    },
    editorWrapper: {
        marginLeft: -22,
        width: 'auto'
    }
};
